module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.16975/js/img/white_sprocket.svg"